import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ConfigIcon } from '../../assets/icons/sidebar/configeration.svg';
import { useAppDispatch } from '../../redux/hooks';
import { setPageTitle } from '../../redux/slices/PageTitleSlice';
import CustomDropDown from '../../shared-components/custom-drop-down/CustomDropDown';
import { permissionCheck } from '../../shared-functions/JWTDocodeFunction';

import AccountLevel from './components/AccountLevel';
import PlatformLevel from './components/PlatformLevel';

/**
 * Fee configuration component
 * @returns {any} The result
 */
function FeeConfiguration() {
  const { t, i18n } = useTranslation('sharedComponent');
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(
      setPageTitle({
        title: t('feeConfiguration'),
        icon: <ConfigIcon />,
      }),
    );
  }, [dispatch, t]);

  return (
    <div className="fee-configuration-wrap" dir={i18n.dir()}>
      <div className="fee-configuration">
        {permissionCheck('mobilityPlatformLevelView') && (
          <CustomDropDown label={t('tenantLevel')} content={<PlatformLevel />} open />
        )}
        {permissionCheck('mobilityAccountLevelView') && permissionCheck('hidden')&& (
          <CustomDropDown label={t('accountLevel')} content={<AccountLevel />} open />
        )}
      </div>
    </div>
  );
}

export default FeeConfiguration;
